import { render, staticRenderFns } from "./multiple-profile-default.vue?vue&type=template&id=3540e7b2&scoped=true&"
import script from "./multiple-profile-default.vue?vue&type=script&lang=js&"
export * from "./multiple-profile-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540e7b2",
  null
  
)

export default component.exports